import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, Gift, CheckCircle2 } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function Bonos() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const bonos = [{
    emoji: '🔥',
    title: 'BONO 1 — BANCO DE EJERCICIOS ACUÁTICOS ILUSTRADO',
    valor: '$12.000',
    bullets: ['+100 ejercicios categorizados por objetivo y zona de trabajo', 'Descripción clara de posición inicial, ejecución y finalización', 'Objetivo específico de cada ejercicio: para qué sirve y cuándo usarlo', 'Variantes por nivel de dificultad: con y sin material', 'Formato visual e imprimible para tener al borde de la pileta', 'Organizado por: zona de trabajo, objetivo y nivel', 'Ejercicios con noodle, tabla, mancuernas y sin material']
  }, {
    emoji: '📊',
    title: 'BONO 2 — PLANILLAS DE SEGUIMIENTO DEL ALUMNO',
    valor: '$10.000',
    bullets: ['Ficha de evaluación inicial del alumno lista para imprimir o completar digital', 'Registro de asistencia semanal y mensual', 'Seguimiento de progreso por nivel y objetivo', 'Historial de clase por alumno', 'Ficha de objetivos personales del alumno', 'Hoja de alta médica simplificada para instructores', 'Formato editable para personalizar con tu marca']
  }, {
    emoji: '🤰',
    title: 'BONO 3 — AQUAGYM PARA EMBARAZADAS',
    valor: '$9.000',
    bullets: ['Beneficios del aquagym durante el embarazo por trimestre', '8 clases completas adaptadas: ritmo, impacto y duración por trimestre', 'Ejercicios contraindicados: qué nunca hacer y por qué', 'Cómo comunicarse con alumnas embarazadas: lenguaje y contención', 'Coordinación con el médico obstetra: cuándo consultar', 'Adaptaciones posturales específicas para cada etapa del embarazo', 'Ficha de derivación al profesional de salud incluida']
  }, {
    emoji: '🏊',
    title: 'BONO 4 — GUÍA COMPLETA DE EJERCICIOS CON NOODLE',
    valor: '$10.000',
    bullets: ['+40 ejercicios exclusivos con noodle descriptos paso a paso', 'Ejercicios para tren superior, inferior y core con noodle', 'Variantes por nivel: cómo hacer el mismo ejercicio más fácil o más difícil', 'Combinaciones de noodle con otros materiales', 'Cómo usar el noodle para flotación y resistencia en la misma clase', 'Formato visual listo para tener al borde de la pileta', 'Progresión de 4 semanas usando solo noodle']
  }, {
    emoji: '📅',
    title: 'BONO 5 — PLANIFICACIÓN ANUAL DE AQUAGYM LISTA',
    valor: '$9.000',
    bullets: ['12 meses de periodización acuática en tablas listas para usar', 'Distribución de objetivos por trimestre: base, intensidad, mantenimiento', 'Planificación adaptada a la estacionalidad argentina', 'Cómo ajustar el plan según asistencia y progreso real del grupo', 'Tabla de progresión anual para alumnas de larga trayectoria', 'Versión para natatorio con pileta climatizada todo el año', 'Versión para espacio con pico estacional en verano']
  }, {
    emoji: '🎤',
    title: 'BONO 6 — GUIÓN DE PRIMERA CLASE Y BIENVENIDA',
    valor: '$8.000',
    bullets: ['Qué decir antes de entrar al agua: presentación profesional', 'Cómo romper el hielo con alumnas nuevas en 5 minutos', 'Guión de bienvenida para grupos nuevos y alumnas sueltas', 'Cómo explicar las reglas del espacio acuático sin sonar rígido/a', 'Cómo generar confianza desde la primera clase', 'Qué decir al final de la clase para que vuelvan la próxima semana', 'Frases de motivación y corrección para usar dentro del agua']
  }];
  return <section className="py-12 md:py-24 bg-slate-50 border-t border-slate-200" id="bonos" data-id="element-18">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-19">
        <FadeIn data-id="element-20">
          <div className="text-center mb-6 md:mb-12" data-id="element-21">
            <div className="inline-flex items-center justify-center w-10 h-10 md:w-16 md:h-16 rounded-full bg-rose-100 text-rose-500 mb-3 md:mb-6" data-id="element-22">
              <Gift className="w-5 h-5 md:w-8 md:h-8" data-id="element-23" />
            </div>
            <h2 className="text-3xl md:text-5xl font-display font-black text-deepblue-900 mb-2 md:mb-4" data-id="element-24">
              Más los 6 Bonos Estratégicos
            </h2>
            <p className="text-base md:text-xl text-slate-600 font-medium" data-id="element-25">
              Incluidos en todas las ofertas — sin costo extra
            </p>
          </div>
        </FadeIn>

        <div className="space-y-2 md:space-y-4 mb-6 md:mb-12" data-id="element-26">
          {bonos.map((bono, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-27">
              <div className={`border rounded-xl md:rounded-2xl overflow-hidden transition-all duration-300 ${openIndex === index ? 'border-rose-400 shadow-lg shadow-rose-100' : 'border-slate-200 hover:border-rose-300 bg-white'}`} data-id="element-28">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className={`w-full flex items-center justify-between p-3 md:p-6 text-left transition-colors ${openIndex === index ? 'bg-rose-50' : 'bg-white'}`} data-id="element-29">
                  <div className="flex items-center gap-2 md:gap-4 flex-1 min-w-0" data-id="element-30">
                    <span className="text-xl md:text-3xl" data-id="element-31">{bono.emoji}</span>
                    <h3 className="font-display font-bold text-xs md:text-xl text-deepblue-900 leading-tight truncate" data-id="element-32">
                      {bono.title}
                    </h3>
                  </div>

                  <div className="flex items-center gap-2 md:gap-4 flex-shrink-0 ml-2" data-id="element-33">
                    <div className="bg-rose-100 text-rose-800 px-2 py-1 md:px-3 md:py-1.5 rounded-md md:rounded-lg text-[10px] md:text-sm font-bold border border-rose-200 whitespace-nowrap hidden sm:block" data-id="element-34">
                      <span className="line-through opacity-60" data-id="element-35">
                        {bono.valor}
                      </span>{' '}
                      → GRATIS
                    </div>
                    <ChevronDown className={`w-5 h-5 md:w-6 md:h-6 text-rose-500 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-36" />
                  </div>
                </button>

                <AnimatePresence data-id="element-37">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} className="overflow-hidden" data-id="element-38">
                      <div className="p-3 md:p-6 pt-0 bg-rose-50 border-t border-rose-100" data-id="element-39">
                        <div className="bg-rose-100 text-rose-800 px-2 py-1 rounded-md text-xs font-bold border border-rose-200 inline-block mb-2 sm:hidden" data-id="element-40">
                          Valor:{' '}
                          <span className="line-through opacity-60" data-id="element-41">
                            {bono.valor}
                          </span>{' '}
                          → GRATIS
                        </div>
                        <ul className="space-y-1.5 md:space-y-3 mt-2 md:mt-4" data-id="element-42">
                          {bono.bullets.map((bullet, i) => <li key={i} className="flex items-start gap-2 md:gap-3" data-id="element-43">
                              <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-rose-500 flex-shrink-0 mt-0.5" data-id="element-44" />
                              <span className="text-slate-700 text-xs md:text-base" data-id="element-45">
                                {bullet}
                              </span>
                            </li>)}
                        </ul>
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn data-id="element-46">
          <div className="bg-gradient-to-r from-rose-500 to-rose-600 rounded-xl md:rounded-2xl p-4 md:p-6 text-center text-white shadow-xl shadow-rose-500/20" data-id="element-47">
            <p className="text-sm md:text-lg font-medium mb-1" data-id="element-48">
              Valor total de los 6 bonos:{' '}
              <span className="line-through opacity-75" data-id="element-49">$58.000</span>
            </p>
            <p className="text-xl md:text-3xl font-display font-black flex items-center justify-center gap-2" data-id="element-50">
              <Gift className="w-5 h-5 md:w-8 md:h-8" data-id="element-51" /> 🎁 GRATIS — Incluidos
              siempre
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}